import { MaskedTextField, MaskedTextFieldProps, Omit } from 'bold-ui'

import { UseFieldProps, usePecField } from '../hooks/useField'
import { getFieldError } from '../util'

export type MaskedFieldProps = UseFieldProps<string> & Omit<MaskedTextFieldProps, 'name'>

export function MaskedField(props: MaskedFieldProps) {
  const { input, meta, ...rest } = usePecField(props)

  return <MaskedTextField error={getFieldError(meta)} {...input} {...rest} />
}
